export enum ScriptKey {
    ERUDA_CONSOLE = 'ERUDA_CONSOLE',
}
